var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Animation',[_c('div',{staticClass:"text",class:_vm.data.textplacement,domProps:{"innerHTML":_vm._s(_vm.$md.render(_vm.data.text))},on:{"click":function($event){return _vm.handleClicks($event, '.text')}}})])}
var staticRenderFns = []

export { render, staticRenderFns }